export enum SwitchOptions {
  OPTION1 = 'OPT1',
  OPTION2 = 'OPT2',
}
type ToggleItemProps = {
  activeOption: SwitchOptions;
  selectedOption: SwitchOptions;
  label: string;
  icon: string;
  iconsStyleOption?: string;
  onSwitchClick: (opt: SwitchOptions) => void;
};

type ToggleButtonProps = {
  toggleSectionId?: string;
  primaryToggleIcon?: string;
  secondaryToggleIcon?: string;
  activeToggleOption: SwitchOptions;
  primaryToggleLabel?: string;
  secondaryToggleLabel?: string;
  iconsStyleOption?: string;
  styleOption?: string;
  disabled?: boolean;
  onSwitchClick: (option: SwitchOptions) => void;
};

export { ToggleItemProps, ToggleButtonProps };
